var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGemBgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 412,
    viewBox: "0 0 430 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter0_f_2134_1550)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363.396 288.064H65.6055L206.664 75L363.396 288.064Z",
    fill: "url(#paint0_linear_2134_1550)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter1_f_2134_1550)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M363.396 123.594H65.6055L206.664 336.657L363.396 123.594Z",
    fill: "url(#paint1_linear_2134_1550)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M288.035 200.78C287.994 200.711 287.972 200.633 287.974 200.553L288.091 195.508L283.78 198.131C283.712 198.173 283.633 198.194 283.553 198.192L278.508 198.075L281.132 202.386C281.173 202.455 281.194 202.533 281.192 202.613L281.076 207.658L285.387 205.035C285.455 204.993 285.534 204.972 285.614 204.974L290.659 205.09L288.035 200.78Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.985 170.539C158.957 170.494 158.943 170.441 158.945 170.388L159.022 167.039L156.161 168.781C156.115 168.809 156.063 168.822 156.01 168.821L152.661 168.744L154.402 171.605C154.43 171.651 154.444 171.703 154.443 171.756L154.365 175.105L157.227 173.363C157.272 173.336 157.325 173.322 157.378 173.323L160.727 173.401L158.985 170.539Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.187 250.21C147.137 250.182 147.096 250.141 147.069 250.092L145.348 246.946L143.628 250.092C143.601 250.141 143.56 250.182 143.51 250.21L140.364 251.93L143.51 253.65C143.56 253.678 143.601 253.719 143.628 253.768L145.348 256.914L147.069 253.768C147.096 253.719 147.137 253.678 147.187 253.65L150.332 251.93L147.187 250.21Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.744,
    cy: 143.529,
    rx: 2.49197,
    ry: 2.49197,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.504,
    cy: 157.235,
    rx: 3.73796,
    ry: 3.73796,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2134_1550",
    x: -9.1537,
    y: 0.240829,
    width: 447.309,
    height: 362.582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.3796,
    result: "effect1_foregroundBlur_2134_1550"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2134_1550",
    x: -9.1537,
    y: 48.8343,
    width: 447.309,
    height: 362.582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.3796,
    result: "effect1_foregroundBlur_2134_1550"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2134_1550",
    x1: 214.501,
    y1: 75,
    x2: 214.501,
    y2: 288.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63A1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104D9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2134_1550",
    x1: 214.501,
    y1: 336.657,
    x2: 214.501,
    y2: 123.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63A1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104D9F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemBgStars);
export default __webpack_public_path__ + "static/media/gem-bg-stars.66c2b72880b6a1fa0bec456b52ff9849.svg";
export { ForwardRef as ReactComponent };